module.exports = __webpack_public_path__ + "static/media/icon13.ba4e4988.svg";